import "./page-landviewer-2026.scss";
import "../../js/core";
import "../../components/site-elements/other-blocks/collapse-content-list/collapse-content-list";
import Collapse from "bootstrap/js/src/collapse";

$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      import(
        /* webpackChunkName: "chunk.owl-carousel-autoplay" */ "owl.carousel/src/js/owl.autoplay"
      ).then(() => {
        const isRtl = () =>
          $("html").attr("dir") === "rtl" || $("body").hasClass("rtl");

        // ===== 1. Первый слайдер =====
        const $introSlider = $(".intro-bg-slider");
        if ($introSlider.length && !$introSlider.hasClass("owl-loaded")) {
          $introSlider.css("opacity", 1);
          $introSlider.owlCarousel({
            rtl: isRtl(),
            items: 1,
            loop: true,
            nav: true,
            dots: true,
            margin: 1,
            smartSpeed: 500,
            slideBy: 1,
            dotsEach: 1,
            autoplay: true,
            autoplayTimeout: 12000,
          });
        }

        // ===== 2. Второй слайдер =====
        $(".slider-mob-card-industries").owlCarousel({
          rtl: isRtl(),
          responsive: {
            0: { items: 1 },
            480: { items: 2 },
            768: { items: 3 },
            992: { items: 4 },
            1241: {
              items: 0,
              dots: false,
              nav: false,
              dotsEach: false,
              margin: 0,
            },
          },
          slideBy: 1,
          dots: false,
          nav: true,
          loop: false,
          margin: 20,
          smartSpeed: 200,
        });

        $(window)
          .on("resize", function () {
            const width = $(window).width();
            const $industries = $(".slider-mob-card-industries");

            $industries.toggleClass("owl-carousel", width <= 1241);

            $(".owl-carousel").each(function () {
              if ($(this).find(".owl-controls").length === 0) {
                const $nav = $(this).find(".owl-nav");
                const $dots = $(this).find(".owl-dots");
                if ($nav.length || $dots.length) {
                  $nav.add($dots).wrapAll("<div class='owl-controls'></div>");
                }
              }
            });
          })
          .trigger("resize");

        $(".owl-carousel").each(function () {
          if ($(this).find(".owl-controls").length === 0) {
            const $nav = $(this).find(".owl-nav");
            const $dots = $(this).find(".owl-dots");
            if ($nav.length || $dots.length) {
              $nav.add($dots).wrapAll("<div class='owl-controls'></div>");
            }
          }
        });
      });
    });
  });
});
